import React, { Component, useState, useEffect, useHistory } from 'react';
import { Editor } from '@tinymce/tinymce-react'; 
import LaravelApi from '../laravelApi/LaravelApi';
import Spinner from '../spinner/Spinner';

const BlogCreateEntrance = (props) => {
  const [blogId, setBlogId] = useState(null);
  const [blogContent, setBlogContent] = useState("");
  const [blogTitle, setBlogTitle] = useState("");

  useEffect(() => {
    if (blogId != null) {
      fetchData();
    }
  
    if (typeof(props.location.state) != 'undefined') {
      setBlogId(props.location.state.id);
    }
    
  }, [blogId]);

  const fetchData = async () => {
    const response = await LaravelApi.get('/blog/'+blogId, {});
    setBlogContent(JSON.parse(response.data.content));
    setBlogTitle(response.data.title);
  }

  const handleEditorChange = (content, editor) => {
    setBlogContent(content);
  }

  const handleSave = (event) => {
    if (blogContent === false | blogTitle === false) {
      alert('No empty stuff!');
    } else {
      if (blogId) {
        const response = LaravelApi.post('/blog/'+blogId, {
          content: blogContent,
          title: blogTitle,
        });
  
      } else {
        const response = LaravelApi.post('/blog', {
          content: blogContent,
          title: blogTitle
        }).then(value => {
          setBlogId(value.data);
        });
      }
      
      alert('blog saved!');
    }
  }

  const handleDelete = (event) => {
    const response = LaravelApi.delete('/blog/'+blogId, {}).then(
      window.location.replace("/nerd-area-list")
    );
  }

  const handleTitleChange = (event) => {
    setBlogTitle(event.target.value);
  }

  if (blogId !== null && blogContent === '') {
    return <Spinner />
  } else {
    return (
      <div>
        <div></div>
        <div className="ui input" >
          <input type="text" onChange={handleTitleChange} value={blogTitle}></input> 
        </div>
        <br></br>
        <Editor
          id="Editor-id"
          initialValue={blogContent}
          init={{
            height: 500,
            menubar: "insert",          
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | code | removeformat | help | image |'
          }}
          onEditorChange={handleEditorChange}
        />
        <br></br>
        <button className="ui primary button" onClick={handleSave}>
          Save
        </button>
        <button className="ui red button"  onClick={handleDelete}>
          Delete
        </button>
      </div>
    )  
  }
}

export default BlogCreateEntrance;
